import { Component, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { getRouteTabBarActivities } from '~/organizer/shared/helpers/activity/list/activity-list-tab-bar.helper';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';

@Component({
  selector: 'app-organizer-activities',
  templateUrl: './activities.component.html',
})
export class OrganizerActivitiesComponent implements OnInit {
  public tabBarlinks: TabBarLinkInterface[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService
  ) {}

  public ngOnInit(): void {
    const tabBarActivities = getRouteTabBarActivities(
      'activity',
      this.translateService,
      this.localizeRouterService
    );

    this.tabBarlinks = this.tabBarlinks?.concat(tabBarActivities);
  }
}
